import type {PDFDocumentProxy} from 'pdfjs-dist';

import {useState} from 'react';

import {PdfPreviewPageRender} from './PdfPreviewPageRender';

type PdfPreviewPageProps = {document: PDFDocumentProxy; pageNumber: number};

export function PdfPreviewPage(props: PdfPreviewPageProps) {
  const [attempt, setAttempt] = useState(0);

  return (
    <PdfPreviewPageRender
      key={attempt}
      document={props.document}
      pageNumber={props.pageNumber}
      onRetry={() => setAttempt(attempt + 1)}
    />
  );
}
